export function getSubdomain(): string {
  const host = window.location.hostname
  const parts = host.split(".")

  // Handle localhost (e.g. tenant1.localhost)
  if (host.endsWith("localhost") && parts.length === 2) {
    return parts[0]
  }

  // Handle production with real subdomains (e.g. tenant1.app.com)
  if (parts.length >= 3) {
    return parts[0] // 'tenant1'
  }

  // Optional: fallback to env or throw
  const fallback = import.meta.env.VITE_DEFAULT_TENANT || ""
  if (!fallback) {
    console.warn("⚠️ Tenant subdomain could not be resolved.")
  }
  return fallback
}
